module.exports = __webpack_public_path__ + "img/02_yellow_dance.5434e685.gif";